import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const images = [
  { src: '/imgf.png', label: 'CSE Department' },
  { src: '/img2.jpg', label: 'Placement Day' },
  { src: '/img7.jpg', label: 'GDSC Team' },
  { src: '/img8.jpg', label: 'Teachers Day 2024' }
];
const interval = 3500; // 3.5 seconds

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
      height: { xs: '65vh', md: '70vh' },
      overflow: 'hidden',
      bgcolor: 'grey.200',
    }}>
      {/* Slide Images */}
      {images.map((img, idx) => (
        <Box
          key={img.src}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: idx === current ? 1 : 0,
            transition: 'opacity 0.8s ease-in-out',
            zIndex: 1,
          }}
        >
          <Box
            component="img"
            src={img.src}
            alt={`slide-${idx}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'fill',
              objectPosition: 'center',
            }}
          />
          <Typography
            variant="body2"
            sx={{
              position: 'absolute',
              bottom: '8px',
              left: '50%',
              transform: 'translateX(-50%)',
              color: 'white',
              textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
              fontSize: '0.875rem',
              fontWeight: 500,
              textAlign: 'center',
              width: '100%',
              padding: '4px',
              backgroundColor: 'rgba(0,0,0,0.3)',
            }}
          >
            {img.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HeroCarousel; 
